module.exports = __webpack_public_path__ + "img/share_loss.fe254892.svg";